import React, { useState } from "react";
import themes from "~/themes";
import * as S from "./styles";

const Input = ({
  marginBottom,
  error,
  label,
  icon = false,
  leftIcon = null,
  typeInput = "text",
  ...rest
}) => {
  const [focusInput, setFocusInput] = useState(false);
  const [showText, setShowText] = useState(false);

  const inputType = icon
    ? showText
      ? "text"
      : "password"
    : typeInput || "text";

  return (
    <S.Container
      marginBottom={marginBottom}
      isFocus={focusInput}
      hasLeftIcon={!!leftIcon}
    >
      <label>{label}</label>

      {leftIcon ? <S.LeftIcon>{leftIcon}</S.LeftIcon> : null}

      <input
        type={inputType}
        onFocus={() => setFocusInput(true)}
        onBlur={() => setFocusInput(false)}
        {...rest}
      />

      {icon ? (
        showText ? (
          <img
            src={themes.components.images.visible}
            onClick={() => setShowText(!showText)}
            className="icon"
            alt="Mostrar senha"
          />
        ) : (
          <img
            src={themes.components.images.invisible}
            onClick={() => setShowText(!showText)}
            className="icon"
            alt="Ocultar senha"
          />
        )
      ) : null}

      {!!error && <S.ErrorText>{error}</S.ErrorText>}
    </S.Container>
  );
};

export default Input;